<fieldset>
 <legend>
  Rectificatif
 </legend>
 <fieldset>
 <legend>
  description
 </legend>
 <app-type-desc-marche  [uid]="getUid()" [parentForm]="parentForm" [description]="rectificatif.description"></app-type-desc-marche>
</fieldset>

<!---->

<fieldset>
 <legend>
  avisInitial
 </legend>
 <app-avis-initial-type  [uid]="getUid()" [parentForm]="parentForm" [avisInitial]="rectificatif.avisInitial"></app-avis-initial-type>
</fieldset>

<!---->

<fieldset>
 <legend>
  procedure
 </legend>
 <app-procedure  [uid]="getUid()" [parentForm]="parentForm" [procedure]="rectificatif.procedure"></app-procedure>
</fieldset>

<!---->

<button class="btn btn-outline-primary" (click)="addtypeInfosRectif()">Ajouter un typeInfosRectif</button>
<div *ngFor="let obj of rectificatif.infosRectif; let i = index">
  <fieldset>
    <legend>
      typeInfosRectif {{ i + 1}}
    </legend>
    <button class="btn btn-outline-primary" (click)="removetypeInfosRectif(i)">Supprimer un typeInfosRectif</button>
    <app-type-infos-rectif [uid]="getUid()+'_index_'+(i+1)" [parentForm]="parentForm" [infosRectif]="obj"></app-type-infos-rectif>
  </fieldset>
</div>

</fieldset>